import {Pathname} from 'history';
import * as React from 'react';
import {Route} from 'react-router';
import * as is from 'is_js';
import {AuthRoute} from '@mintdata-wsp/wsp/ui/routes/AuthRoute';
import {Routing} from '@mintdata-wsp/wsp/ui/routes/Routing';
import {Routes} from '@mintdata-wsp/wsp/ui/routes/RouteConfig';

export class RouteUtil
{
    private static readonly VISUAL_DESIGNER_PAGE = `/visual-designer/designer.html`;
    private static readonly PAGE_404:string = 'page404';

    private static _allRoutesCache:(Route | AuthRoute)[] = null;
    private static _skipPagesForSupportBrowserCheck:Set<Pathname> = null;

    public static getVisualDesignerIFrameSrc():string
    {
        return RouteUtil.VISUAL_DESIGNER_PAGE;
    }

    public static get404Route():any
    {
        return Routing.routes().page404();
    }

    public static getAllRoutes():(Route | AuthRoute)[]
    {
        if( RouteUtil._allRoutesCache === null )
        {
            const routes = Routing.routes();
            RouteUtil._allRoutesCache = RouteUtil._computeAllRoutes(routes) as any;
        }

        return RouteUtil._allRoutesCache;
    }

    private static _computeAllRoutes(routes:Routes)
    {
        const allRoutes = [];

        for( let routeFnKey in routes )
        {
            if( routes.hasOwnProperty(routeFnKey) )
            {
                if( routeFnKey !== RouteUtil.PAGE_404 )
                {
                    const routeFn = (routes as any)[routeFnKey];

                    if( typeof routeFn === 'function' )
                    {
                        const reactRouteElement = routeFn();
                        const clonedElem = React.cloneElement(reactRouteElement, {key: routeFnKey}, reactRouteElement.props.children);

                        allRoutes.push(clonedElem);
                    }
                }
            }
        }

        return allRoutes;
    }

    public static needsRedirectToUnsupportedPage(pathname:Pathname)
    {
        if( RouteUtil._skipPagesForSupportBrowserCheck === null )
        {
            RouteUtil._skipPagesForSupportBrowserCheck = new Set<Pathname>([
                Routing.paths().index().toLocaleLowerCase(),
                Routing.paths().login().toLocaleLowerCase(),
                Routing.paths().signup().toLocaleLowerCase(),
                Routing.paths().unsupported().toLocaleLowerCase(),
            ]);

        }

        return !RouteUtil._skipPagesForSupportBrowserCheck.has(pathname.toLocaleLowerCase()) && RouteUtil._isUserBrowserUnsupported();
    }

    private static _isUserBrowserUnsupported():boolean
    {
        // return is.not.desktop() || (is.not.chrome('>=50') && is.not.firefox('>=44'));
        // TODO
        return false;
    }

    // https://caniuse.com/#feat=urlsearchparams
    // TODO: use URLSearchParams
    public static getQueryVariable(variable:string, query?:string):string | null
    {
        if( !query ) query = window.location.search;

        if( query.charAt(0) === '?' ) query = query.substring(1);

        const vars = query.split('&');

        for( let i = 0; i < vars.length; i++ )
        {
            const pair = vars[i].split('=');

            if( pair[0] === variable ) return decodeURIComponent(pair[1]);
        }

        return null;
    }
}
